export const requiredContrastColors = ["salmon", "pink", "yellow"];